/**
 * Calcule le centre de la carte à partir d'une liste de coordonnées.
 * @param {Array} imagesWithCoords - Liste d'images avec latitude/longitude.
 * @returns {Object} { center: [lat, lon], hasValidCenter: boolean }
 */
export const calculateMapCenter = (imagesWithCoords) => {
    if (imagesWithCoords.length === 0) {
        return { center: [46.5, -1.8], hasValidCenter: false };
    }

    const coords = imagesWithCoords.map((img) => [img.coords.lat, img.coords.lng]);
    const avgLat = coords.reduce((sum, coord) => sum + coord[0], 0) / coords.length;
    const avgLon = coords.reduce((sum, coord) => sum + coord[1], 0) / coords.length;

    return { center: [avgLat, avgLon], hasValidCenter: true };
};
